import { useMapFiltersStore } from "../../../stores/filterMapStore";
import MultiplexIcon from "../../../assets/icons/multiplexTypeIcon.svg";
import VacantLandIcon from "../../../assets/icons/vacantLandTypeIcon.svg";
import DetachedTypeIcon from "../../../assets/icons/DetachedTypeIcon.svg";
import CondominiumIcon from "../../../assets/icons/condominiumTypeIcon.svg";
import SemiDetachedIcon from "../../../assets/icons/semiDetachedTypeIcon.svg";
import CondoTownhouseTypeIcon from "../../../assets/icons/condoTownhouseTypeIcon.svg";
import FreeholdTownhouseIcon from "../../../assets/icons/freeholdTownhouseTypeIcon.svg";

import "./filterPanelStyles.css";

interface PropertyTypeSelectorProps {
  origin: string;
}

export const propertyTypeLabels = [
  { label: "All types" },
  { label: "Detached", icon: DetachedTypeIcon },
  { label: "Semi-Detached", icon: SemiDetachedIcon },
  { label: "Freehold Townhouse", icon: FreeholdTownhouseIcon },
  { label: "Condo Townhouse", icon: CondoTownhouseTypeIcon },
  { label: "Condo Apt", icon: CondominiumIcon },
  { label: "Multiplex", icon: MultiplexIcon },
  { label: "Vacant Land", icon: VacantLandIcon },
];

function PropertyTypeSelector() {
  const { propertyTypeLocal, setPropertyTypeLocal } = useMapFiltersStore();

  const handlePropertyTypes = (label: string) => {
    const propertyLabel = label as string;
    const allType = "All types";

    setPropertyTypeLocal((prevTypes: string[]) => {
      if (propertyLabel === allType) {
        return [allType];
      }
      if (propertyLabel === allType) {
        return prevTypes.includes(allType) ? [] : [allType];
      }
      const updatedTypes = prevTypes.includes(propertyLabel)
        ? prevTypes.filter((item) => item !== propertyLabel)
        : [...prevTypes.filter((item) => item !== allType), propertyLabel];

      return updatedTypes.length === 0 ? [allType] : updatedTypes;
    });
  };

  return (
    <div className="grid grid-cols-4 gap-4 h-fit">
      {propertyTypeLabels.map((property) => (
        <div
          key={property.label}
          className={`border-[1px] w-[100px] cursor-pointer h-[122px] space-y-3 first:px-6 first:leading-6 first:text-[20px] text-center text-xs flex flex-col items-center justify-center border-[#F0F0F0] rounded-xl px-1 ${
            propertyTypeLocal.includes(property.label)
              ? "bg-z-dark-moss-green text-white"
              : "text-[#999]"
          }`}
          onClick={() => handlePropertyTypes(property.label)}
          onKeyDown={() => handlePropertyTypes(property.label)}
        >
          {property.icon && (
            <img
              src={property.icon}
              alt="Building Icon"
              className=""
              style={{
                filter: propertyTypeLocal.includes(property.label)
                  ? "invert(0) grayscale(0) contrast(100)"
                  : "invert(1) grayscale(1) contrast(100%)",
              }}
            />
          )}

          <div className="font-medium">{property.label}</div>
        </div>
      ))}
    </div>
  );
}

export { PropertyTypeSelector };
